import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { FilePreviewType } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import { JgVisualInspReportFile } from 'src/app/modules/shared/models/jg/jg-visual-insp-report-file.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { JgVisualInspReportFileService } from 'src/app/modules/shared/services/jg-visual-insp-report-file.service';

@Component({
  selector: 'app-dialog-jg-visual-report-upload',
  templateUrl: './dialog-jg-visual-report-upload.component.html',
  styleUrls: ['./dialog-jg-visual-report-upload.component.scss'],
})
export class DialogJgVisualReportUploadComponent {
  @Input()
  data!: DialogConfig<JgVisualInspReportFile>;

  fileType: FilePreviewType = FilePreviewType.PDF;

  editing: { [name: string]: boolean } = {};

  record: JgVisualInspReportFile = new JgVisualInspReportFile();

  fileUrls: string[] = [];

  files: FileResponse[] = [];

  constructor(
    private jgVisualInspReportFileService: JgVisualInspReportFileService,
    private globalService: GlobalService,
  ) {}

  ngOnInit() {
    this.record = this.data.data ?? new JgVisualInspReportFile();
  }

  edit(name: string) {
    this.editing[name] = true;
  }

  onBlur() {
    this.editing = {};
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  onFileChange(fileResponses: FileResponse[]) {
    this.files = fileResponses;
    console.log('fileResponses', fileResponses);
    this.fileUrls = fileResponses.map((fileResponse) => fileResponse.fileId);
  }

  private handleDataBeforeConfirm(
    response: JgVisualInspReportFile,
  ): JgVisualInspReportFile {
    const data = JSON.parse(JSON.stringify(response)) as JgVisualInspReportFile;

    return data;
  }

  get canConfirm() {
    if (
      this.fileUrls?.length === 0 ||
      this.record.fileSn === undefined ||
      this.record.fileSn === ''
    ) {
      return false;
    }

    return true;
  }

  private submit() {
    this.record.fileId = this.files?.[0]?.fileId;
    this.record.fileName = this.files?.[0]?.fileName;
    this.record.fileMd5 = this.files?.[0]?.fileMd5;
    this.jgVisualInspReportFileService
      .create(this.handleDataBeforeConfirm(this.record))
      .subscribe((response: JgVisualInspReportFile) => {
        if (response) {
          this.data.onConfirm!();
        }
      });
  }
}
